import { isBrowser } from "./isBrowser"

export async function registerServiceWorker(): Promise<void> {
  if (isBrowser() && "serviceWorker" in navigator) {
    try {
      const blockExternals =
        sessionStorage.getItem("sw-block-externals") === "1" ? 1 : 0
      const { hostname } = new URL(window.location.href)

      await navigator.serviceWorker.register(
        `/sw.js?block-externals=${blockExternals}&hostname=${hostname}`
      )
    } catch (error) {
      console.error(`Registration failed with ${error}`)
    }
  }
}
